import axios from 'axios'
import PropTypes from 'prop-types'
import { kea } from 'kea'
import { put, call } from 'redux-saga/effects'
import DataLogicV2 from 'containers/AppV2/logic'
import omit from 'lodash/omit'

import { API_BASE_URL_V2 } from 'config'

import { csObjectToUnderscore } from 'utils'

const FEEDBACK_ENDPOINT = `${API_BASE_URL_V2}/public/simulator/feedback/`

const DEFAULT_VALUES = {}

export default kea({
  connect: {
    props: [DataLogicV2, ['translations']],
  },

  actions: () => ({
    sendFeedback: (code) => ({ code }),
    resetForm: () => ({}),
    setFormValues: (selected) => selected,
    deleteFormValue: (key) => ({ key }),
    setFeedbackError: (message) => ({ message }),
  }),
  reducers: ({ actions }) => ({
    formValues: [
      DEFAULT_VALUES,
      PropTypes.object,
      {
        [actions.setFormValues]: (state, payload) => ({ ...state, ...payload }),
        [actions.resetForm]: () => ({ ...DEFAULT_VALUES }),
        [actions.deleteFormValue]: (state, payload) => omit(state, payload.key),
      },
    ],
    loading: [
      false,
      PropTypes.bool,
      {
        [actions.sendFeedback]: () => true,
        [actions.setFormValues]: () => false,
        [actions.resetForm]: () => false,
        [actions.deleteFormValue]: () => false,
        [actions.setFeedbackError]: () => false,
      },
    ],
  }),
  takeLatest: ({ actions, workers }) => ({
    [actions.sendFeedback]: workers.sendFeedback,
  }),

  workers: {
    *sendFeedback() {
      const { setFeedbackError, resetForm } = this.actions
      const { onClose, formValues } = this.props

      let form = csObjectToUnderscore(formValues)
      if (form.key) {
        delete form.key
      }

      try {
        yield call(axios.post, FEEDBACK_ENDPOINT, {
          ...form,
        })

        yield put(resetForm())
        document.cookie =
          'feedbackSubmitted=true; path=/; max-age=' + 365 * 24 * 60 * 60
        onClose && onClose()
      } catch (error) {
        yield put(setFeedbackError(error))
      }
    },
  },
})



// WEBPACK FOOTER //
// ./src/components/FeedbackModalV2/logic.js